import { createStore } from '@shared/store';
import { UserDetailsType } from '@shared/types';
import {
  ServiceLocationDetailsObjectType,
  BinaryOptionsType,
  CaseIDProps,
  BasicAssetType,
} from '@types';
import {
  BOLLARD_LIT,
  BOLLARD_UNLIT,
  SIGN_LIT,
  SIGN_UNLIT,
  STREET_NAME_SIGN_UNLIT,
} from '../constants/signsBollards';

type ServiceLocationDetailsType = ServiceLocationDetailsObjectType & {
  additional_details?: string;
};

export type IssueType =
  | typeof BOLLARD_LIT
  | typeof BOLLARD_UNLIT
  | typeof SIGN_UNLIT
  | typeof STREET_NAME_SIGN_UNLIT
  | typeof SIGN_LIT
  | '';

const initialData = {
  uploadedImages: [],
  uploadedImagesFileName: [],
  uploadedImagesFileType: [],
  uploadedImagesBlob: [],
  serviceLocationDetailsFromFile:
    [] as unknown as ServiceLocationDetailsObjectType,
  serviceLocationDetails: [] as unknown as ServiceLocationDetailsType,
  assetDetails: null,
  fileWithLoadedCoordinates: '',
  isPhotoLocationStored: false,
  issueLocationMoreInfo: '',
  wantConfirmationEmail: '' as BinaryOptionsType,
  contactUserOption: '',
  caseReferenceId: '',
  slaText: '',
  userDetails: {
    firstName: '',
    lastName: '',
    email: '',
    contactId: '',
  },
  sessionId: '',
  issueType: '' as IssueType,
  moreDetails: '',
  fileDetailsObjects: [],
  issueLocationType: null,
  confirmation: undefined,
};

interface useSignsBollardsStoreType {
  uploadedImages: string[];
  uploadedImagesFileName: string[];
  uploadedImagesFileType: string[];
  uploadedImagesBlob: {
    blob_uri: string;
    blob_endpoint: string;
    filename: string;
  }[];
  serviceLocationDetailsFromFile: ServiceLocationDetailsObjectType;
  serviceLocationDetails: ServiceLocationDetailsType;
  assetDetails: BasicAssetType | null;
  fileWithLoadedCoordinates: string;
  isPhotoLocationStored: boolean;
  issueLocationMoreInfo: string;
  wantConfirmationEmail: BinaryOptionsType;
  contactUserOption: string;
  caseReferenceId: string;
  slaText: string;
  userDetails: UserDetailsType;
  sessionId: string;
  issueType: IssueType;
  moreDetails: string;
  fileDetailsObjects: { name: string; path: string }[];
  confirmation: CaseIDProps | undefined;
}

export const useSignsBollardsStore = createStore<useSignsBollardsStoreType>({
  initialData,
  name: 'signs-and-bollards-store',
  persist: true,
  enableDevTools: false,
});

/**
 * Function to reset user details
 * Note: use getState() to access Zustand store method outside of a React component
 * */
export const resetUserDetails = () => {
  useSignsBollardsStore.getState().resetSelective(['userDetails', 'sessionId']);
};

export const resetIssueDetails = () => {
  useSignsBollardsStore
    .getState()
    .resetSelective([
      'uploadedImages',
      'uploadedImagesFileName',
      'uploadedImagesFileType',
      'uploadedImagesBlob',
      'serviceLocationDetails',
      'fileWithLoadedCoordinates',
      'isPhotoLocationStored',
      'issueLocationMoreInfo',
      'issueType',
      'moreDetails',
    ]);
};

export const updateStoreByKey = (key: string, value: any) => {
  useSignsBollardsStore
    .getState()
    .update(key as keyof useSignsBollardsStoreType, value);
};
